module.exports = __webpack_public_path__ + "img/resident-scholars.9807d074.webp";